module.exports = __webpack_public_path__ + "img/Carrousels STARTO – après rdv_slide_3.20b284da.png";